// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3x-Qz","colMin":"styles_colMin__3tM8Q","colCheckbox":"styles_colCheckbox__32d6m"};